import {RequiredTaggingModel} from '../../../../../../models/api/requiredTaggingModel';
import {RuleCompoundConditions, RuleCompoundConditionTypesEnum} from '../../../../../../models/api/ruleModel';
import {SafetyNetModel} from '../../../../../../models/api/safetyNetModel';
import {RuleIntegration} from '../../../../ruleIntegrationModel';
import {getRuleEditorErrorsForChecks} from '../../../ruleEditorErrors';
import {RuleEditorState} from '../../../state/ruleEditorState';
import {RequiredTaggingEditorErrorsEnum} from '../requiredTaggingEditorErrors';
import {
  getRequiredTaggingParamsErrors,
  RequiredTaggingParamsEditorState,
} from './requiredTaggingParamsEditorState';

export type RequiredTaggingEditorState = RuleEditorState & RequiredTaggingParamsEditorState;

export function getRequiredTaggingErrors(
  state: RequiredTaggingEditorState,
  ruleIntegration: RuleIntegration,
  safetyNets: ReadonlyArray<SafetyNetModel>,
  hasHighlightErrorsFlag: boolean,
): ReadonlyArray<RequiredTaggingEditorErrorsEnum> {
  const requiredTaggingParamsErrors = getRequiredTaggingParamsErrors(
    state,
    safetyNets,
    hasHighlightErrorsFlag,
  );

  const ruleEditorErrors = getRuleEditorErrorsForChecks(
    state,
    ruleIntegration,
    ['name', 'conditions', 'errors'],
    hasHighlightErrorsFlag,
  );

  return [...ruleEditorErrors, ...requiredTaggingParamsErrors];
}

export function requiredTaggingToBundle(state: RequiredTaggingEditorState): RequiredTaggingModel {
  return {
    name: state.ruleState.name,
    conditions: [
      RuleCompoundConditionTypesEnum.AND,
      ...state.ruleState.conditions.map((orConditions) => [
        RuleCompoundConditionTypesEnum.OR,
        ...orConditions,
      ]),
    ] as RuleCompoundConditions,
    requiredTaggingParams: state.requiredTaggingParamsState.map((requiredTaggingParameter) => ({
      tagListName: requiredTaggingParameter.tagListName,
      isOneTagRequired: requiredTaggingParameter.isOneTagRequired,
      tagIds: requiredTaggingParameter.tagIds,
    })),
  };
}
